import React from "react";
import Home from "../views/frontOfficeView/Home";
import { Navigate, Outlet, Route, Routes } from "react-router";
import ProductDetails from "../views/frontOfficeView/ProductDetails";
import ProductsByCategorie from "../views/frontOfficeView/ProductsByCategorie";
import DashboardBackoffice from "../views/backofficeView/DashboardBackoffice";
import ProduitsBackoffice from "../views/backofficeView/produits/ProduitsBackoffice";
import Followers from "../views/backofficeView/Followers";
import Abonnement from "../views/backofficeView/Abonnement";
import AuthCallback from "../components/AuthCallback"
import Commandes from "../views/backofficeView/commande/Commandes";
import Favoris from "../views/frontOfficeView/Favoris"
import Parametrages from "../views/backofficeView/parametres/Parametrages";
import Apropos from "../views/frontOfficeView/Apropos";
import Installation from "../views/servicesBoutique/Installation";
import Technique from "../views/servicesBoutique/Technique"
import Maintenance from "../views/servicesBoutique/Maintenance";
import Signup from "../../src/components/Signup";
import { isAuthenticated } from "../utils/AuthGuard";
import Administrateurs from "../views/backofficeView/administrateur/Adminatrateurs";
import AllProduits from "../views/frontOfficeView/AllProduits";
import CompteClients from "../views/backofficeView/clients/CompteClients";

const AppRoutes = () => {
  const ProtectedRoute = () => {
    return isAuthenticated() ? <Outlet /> : <Navigate to="/" />;
  };

  return (
    <Routes>
      {/* Routes publiques */}
      <Route path="/" element={<Home />} />
      <Route path="/product-details/:id" element={<ProductDetails />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/favoris" element={<Favoris />} /> 
      <Route
        path="/allproduits"
        element={<AllProduits />}
      />
      <Route
        path="/allproduits/:params"
        element={<AllProduits />}
      />
      {/* <Route
        path="/allproduits/search/:params"
        element={<AllProduits />}
      /> */}
      
      
      <Route path="/apropos" element={<Apropos />} />
      <Route path="/service-installation" element={<Installation />} />
      <Route path="/service-technique" element={<Technique />} />
      <Route path="/service-maintenance" element={<Maintenance />} />

      {/* Routes protégées */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<DashboardBackoffice />} />
        <Route path="/produits" element={<ProduitsBackoffice />} />
        <Route path="/comptesClients" element={<CompteClients />} />
        
        <Route path="/commandes" element={<Commandes />} />
        <Route path="/admins" element={<Administrateurs />} />
        <Route path="/parametrages" element={<Parametrages />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
